<div>
  <po-widget class="po-xl-3 po-lg-3 po-md-3 po-sm-3 npl" [p-no-shadow]="true" [p-primary]="true"
    style="color: white; position: relative" p-height="470px">
    <div class="cp-widget np">
      <cp-taskstatus [taskitem]="taskitem"></cp-taskstatus>
    </div>
  </po-widget>
  <div class="po-xl-9 po-lg-9 po-md-9 po-sm-9 npl">
    <po-widget class="po-xl-4 po-lg-4 po-md-4 po-sm-4" [p-no-shadow]="true" style="position: relative">
      <div class="cp-widget np">
        <cp-taskcost [taskitem]="taskitem"></cp-taskcost>
      </div>
    </po-widget>
    <po-widget class="po-xl-4 po-lg-4 po-md-4 po-sm-4" [p-no-shadow]="true" style="position: relative">
      <div class="cp-widget">
        <cp-taskorders [taskitem]="taskitem"></cp-taskorders>
      </div>
    </po-widget>
    <po-widget class="po-xl-4 po-lg-4 po-md-4 po-sm-4" [p-no-shadow]="true" style="position: relative">
      <div class="cp-widget">
        <cp-taskorderextras [taskitem]="taskitem"></cp-taskorderextras>
      </div>
    </po-widget>
    <div class="np">
      <po-widget class="po-xl-12 po-lg-12 po-md-12 po-sm-12" style="margin-top: 10px; position: relative" [p-no-shadow]="true" p-height="139">
        <cp-taskcontract [taskitem]="taskitem"></cp-taskcontract>
      </po-widget>
    </div>
  </div>
</div>
